import { useMemo } from 'react';

import { getInteractiveQuestionsRankingColor } from '../../../../../../../../utils/getInteractiveQuestionsRankingColor';
import { stringHashCode } from '../../../../../../../../utils/stringHashCode';
import { StyledImage, StyledSvg } from './Quote.styled';

interface QuoteProps {
  name: string;
}

// We use this technique instead of mask-image css property due to some times, with css, the image is not shown.
export const Quote = ({ name }: QuoteProps) => {
  const hash = useMemo(() => stringHashCode(name), [name]);

  return (
    <StyledSvg>
      <defs>
        <filter id={`quoteColorMask-${hash}`}>
          <feFlood
            floodColor={getInteractiveQuestionsRankingColor(hash)}
            result="flood"
          />
          <feColorMatrix
            result="inv"
            in="SourceGraphic"
            type="matrix"
            values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
          />
          <feComposite
            in="inv"
            in2="flood"
            operator="arithmetic"
            k1="1"
            k2="0"
            k3="0"
            k4="0"
          />
        </filter>
      </defs>

      <StyledImage
        filter={`url(#quoteColorMask-${hash})`}
        href="https://static.genially.com/genially/activities/quotes.svg"
      />
    </StyledSvg>
  );
};
